"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPageLevelStyle = exports.componentLevelStyle = void 0;
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
exports.componentLevelStyle = {
    textContainer: react_1.css({
        margin: '24px 0',
    }),
    description: react_1.css({
        maxWidth: 352,
        textAlign: 'center',
        marginTop: 4,
    }),
};
var createPageLevelStyle = function (position) { return ({
    textContainer: react_1.css({
        marginBottom: 32,
        marginLeft: position === 'left' ? 24 : undefined,
        marginTop: position === 'center' ? style_1.pxToRem(32.6) : undefined,
    }),
    description: react_1.css({
        maxWidth: 352,
        textAlign: 'center',
        marginTop: 8,
    }),
}); };
exports.createPageLevelStyle = createPageLevelStyle;
